import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getRequest, postRequest } from '../../../../helpers/request'
import { appApi } from '../../../../utils/endpoints/appApi'
import { clearAll, onChangeStatus, onDeleteLetter, onResendLinkToBank, setErrorMessageTransfereeUser, setLoadingTransfereeUser, showDeleteConfirmationFunc, showResendLinkConfirmationFunc, showStatusChangeConfirmationFunc } from '../../../../config/redux/slice/transfereeUserSlice'
import { Spinner } from '../../../components'

export default function ResendLinkConfirmation() {
    const dispatch = useDispatch()
        const {
        transfereeUserLoading,
        transfereeUserErrorMsg,
        certificateManagement:{certificateDetails}
    } = useSelector((state) => state.transfereeUser)
    const {
        token
    } = useSelector((state) => state.authData)

    const closeModal = () => {
        dispatch(clearAll({}))
        dispatch(showResendLinkConfirmationFunc({ modal: false }));
    };

    const confirmAction = async () =>{
        dispatch(clearAll({}))
        const res = await postRequest(
        token,
        `${appApi.resendLinkToBank}`,
        {
            certificate_id: certificateDetails?.ID,
        },
        dispatch,
        setLoadingTransfereeUser,
        "",
        setErrorMessageTransfereeUser
      )
      if(res !== undefined && res.status < 400){
          dispatch(onResendLinkToBank({message: res.data.message}))
      }
    }
  return (
        <div 
        className="modal fade show" 
        id="basicModal" 
        tabIndex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.3)",
          overflowY: 'auto'
        }}
     >
  <div style={{overflowY: 'auto'}} className="modal-dialog modal-dialog-centered modal-md" role="document">
    <div className="modal-content">
        <div className="modal-header px-4">
          <h5 className="modal-title" id="exampleModalCenterTitle">Resend Link</h5>
          <button 
            type="button" 
            className="close" 
            data-dismiss="modal" 
            aria-label="Close"
            onClick={()=>{closeModal()}}
        >
          <span aria-hidden="true">×</span>
        </button>
        </div>
        <div className='modal-body'>
            <div className={'px-sm-1 px-md-2 pb-2'}>
                <p style={{lineHeight: '2rem'}}>
                    Are you sure you want to resend the request link to your bank contact?
                </p>
            </div>
        </div>
      <div className="modal-footer px-4 d-flex align-items-center">
          <button disabled={transfereeUserLoading ? true : false} onClick={()=>{closeModal()}} type="button" className="btn btn-smoke" data-dismiss="modal">Cancel</button>
          <div>
          {transfereeUserLoading ? 
            <Spinner/> :
            <button onClick={confirmAction} type="button" className="btn btn-danger">Resend</button>
          }
        </div>
        </div>
    </div>
  </div>
</div>
  )
}
